import { IStringDate } from './types';

export const getYear = (date: IStringDate): number => {
  return Number(date.split('-')[0]);
};
